import { ClearFiltersIcon, SearchIcon } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { CONTEXT_SOURCE_DEFAULT_SORT_DIRECTIONS, type ContextSourceSortColumn } from '@/types/contextSource'
import { X } from 'lucide-react'

interface ContextSourcesFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  sortBy: ContextSourceSortColumn
  sortDirection: 'asc' | 'desc'
  onClearAll: () => void
}

export function ContextSourcesFilters({ search, onSearchChange, sortBy, sortDirection, onClearAll }: ContextSourcesFiltersProps) {
  const hasActiveSort = sortBy !== 'createdAt' || sortDirection !== CONTEXT_SOURCE_DEFAULT_SORT_DIRECTIONS.createdAt
  const hasActiveFilters = search !== '' || hasActiveSort

  return (
    <div className="flex items-center gap-4">
      <div className="relative flex-1 max-w-[652px]">
        <SearchIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-card-foreground" />
        <Input
          placeholder="Search by name or description"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 pr-9 rounded-lg border border-border"
          aria-label="Search context sources"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      <Button
        type="button"
        variant="ghost"
        onClick={onClearAll}
        disabled={!hasActiveFilters}
        className="flex items-center gap-1.5 text-sm font-medium"
        aria-label="Clear all filters"
      >
        <ClearFiltersIcon className="h-4 w-4" />
        Clear All
      </Button>
    </div>
  )
}
